import { render } from "./TicketTable.vue?vue&type=template&id=39d5b206"
import script from "./TicketTable.vue?vue&type=script&lang=js"
export * from "./TicketTable.vue?vue&type=script&lang=js"

import "./TicketTable.vue?vue&type=style&index=0&id=39d5b206&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__